/*
 * --------------------------------------------------------------------------- *
 * File: ModalManager.js                                                       *
 * Project: web                                                                *
 * Created Date: 07 Nov 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Wed Nov 09 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import React, { useState } from "react";
import Modal from "react-modal";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundImage: "url('background.jpg')",
    border: "solid",
    borderWidth: "10",
    borderColor: "blue",
  },
};
Modal.setAppElement("#root");

function ValidationModal({ messages, setMessages, resolveRef, moveForward }) {
  return (
    <Modal
      isOpen={messages.length > 0}
      //onAfterOpen={afterOpenModal}
      onRequestClose={(e) => {
        setMessages([]);
        resolveRef.current(false);
      }}
      style={modalStyle}
      contentLabel="Warning"
    >
      <div className="container">
        <div className="row">
          <div className="col-12 p-2 mb-2 bg-warning bg-gradient text-light">
            <h3>Warning</h3>
          </div>
          <div className="col-12">
            {messages.map((m, i) => (
              <p key={i}>{m}</p>
            ))}
          </div>
          <div className="col-12 right">
            <button
              className="btn btn-sm btn-primary m-1"
              onClick={(e) => {
                setMessages([]);
                resolveRef.current(true);
              }}
            >
              Ignore
            </button>
            <button
              className="btn btn-sm btn-primary m-1"
              onClick={(e) => {
                setMessages([]);
                resolveRef.current(false);
              }}
            >
              Fix now
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ValidationModal;
